"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutStatus = exports.AuthorizationStatusResult = exports.WORKFLOW_CANCEL_REASON = void 0;
var WORKFLOW_CANCEL_REASON;
(function (WORKFLOW_CANCEL_REASON) {
    WORKFLOW_CANCEL_REASON["USER_CANCEL"] = "USER_CANCEL";
    WORKFLOW_CANCEL_REASON["API_ERROR"] = "API_ERROR";
    WORKFLOW_CANCEL_REASON["EXCEED_2FA_OTP"] = "EXCEED_2FA_OTP";
    WORKFLOW_CANCEL_REASON["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
})(WORKFLOW_CANCEL_REASON = exports.WORKFLOW_CANCEL_REASON || (exports.WORKFLOW_CANCEL_REASON = {}));
var AuthorizationStatusResult;
(function (AuthorizationStatusResult) {
    AuthorizationStatusResult["SUCCESS"] = "SUCCESS";
    AuthorizationStatusResult["FAILED"] = "FAILED";
    AuthorizationStatusResult["MAX_TRY_COUNTS"] = "MAX_TRY_COUNTS";
})(AuthorizationStatusResult = exports.AuthorizationStatusResult || (exports.AuthorizationStatusResult = {}));
var LayoutStatus;
(function (LayoutStatus) {
    LayoutStatus["NULL"] = "NULL";
    LayoutStatus["ONE_TOKEN"] = "ONE_TOKEN";
    LayoutStatus["ONE_TOKEN_WITH_FOOTER"] = "ONE_TOKEN_WITH_FOOTER";
    LayoutStatus["OTP"] = "OTP";
    LayoutStatus["LOST_OR_CHANGED"] = "LOST_OR_CHANGED";
    LayoutStatus["VERIFY_SUCCESS"] = "VERIFY_SUCCESS";
    LayoutStatus["VERIFY_SUCCESS_DISMISS"] = "VERIFY_SUCCESS_DISMISS";
    LayoutStatus["TOKEN_VALIDATION"] = "TOKEN_VALIDATION";
    LayoutStatus["HARD_WARE_TOKEN"] = "HARD_WARE_TOKEN";
})(LayoutStatus = exports.LayoutStatus || (exports.LayoutStatus = {}));
